<template>
  <div> 
    <div class="row">
        <div class="col-md-5">
            <label for="diasemovimento">Dias sem movimento:</label>
            <input type="number" min="0" name="diasemovimento"
                class="form-control form-control-sm"
                v-model="pdiasemovimento"
                @input="removeMinusSign">
        </div>
        <div class="col-md-4">
            <label for="cbqtdreg">Reg.:</label>
            <select name="cbqtdreg"
                    class="form-control form-control-sm"
                    v-model="pqtdregistros">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div class="col-md-3 d-flex align-items-end">
            <button class="btn btn-primary btn-sm w-100" @click="mtdresultadoprod()">Atualizar</button>
        </div>
    </div>
    <div  class="row" style="padding-top: 25px;">
        <div class="col-md-12">
            <div :style="pqtdregistros >= 20 ? 'max-height: 150px; overflow-y: auto;' : ''">
                <div :style="estiloScrollLista">
                    <ul style="padding-left: 0px; margin-bottom: 0px; padding-bottom: 5px;">
                        <li v-for="(item, indice) in lstprodutosparados" :key="indice" class="li-item-card-dash" style="height: 15px;">
                            <div class="row">
                                <div class="col-8">
                                    <h5 class="txt-item-card-dash-top5-desc" v-bind:title="item.descricao">{{ item.idproduto }} - {{ item.descricao }}</h5>
                                </div>
                                <div class="col-4 text-right valconainer">
                                    <template>
                                        <h5 class="txt-item-card-dash-top5-val">{{item.dtultimavenda }}</h5>
                                    </template>
                                </div>
                            </div>                                                    
                        </li>
                    </ul>  
                </div>
            </div>                                          
        </div>
    </div>
  </div>
</template>

<script>
import util from '../../utilitarios/util';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "BarChartCard",

  components:{
    'dashboard_skeleton'   : Skeletondashboard
  },
  data : function name(params) {
    return {
      usuariologado               : this.$store.state.usuario,

      pdiasemovimento: 0,
      pqtdregistros: 10,
      lstprodutosparados  : [],
      isloading     : false,
  
    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
     'qtdnotaspendentes',
  ],
  methods:{
        removeMinusSign() {
            // Remove o caractere "-" do valor do input
            this.pdiasemovimento = this.pdiasemovimento.replace(/-/g, "");
        },
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdmaisfiltro(){
            let rfiltro = '';
            // if (parseInt(this.pdiasemovimento) > 0) {//guga - 24/10/2024 - 🤠
                const dataAtual = new Date();
                const diasemovimento = parseInt(this.pdiasemovimento);
        
                const dataLimiteInferior = new Date();
                dataLimiteInferior.setDate(dataAtual.getDate() - diasemovimento);

                // const dataLimiteSuperior = new Date();
                // dataLimiteSuperior.setDate(dataAtual.getDate() - diasemovimento + 1);

                const formatoData = (data) => {
                    const ano = data.getFullYear();
                    const mes = String(data.getMonth() + 1).padStart(2, '0');
                    const dia = String(data.getDate()).padStart(2, '0');

                    return `${ano}-${mes}-${dia}`;
                };

                // Filtro para produtos com exatamente 'pdiasemovimento' dias sem vendas
                rfiltro = rfiltro + ' and p.dtultimavenda < "' + formatoData(dataLimiteInferior) + ' 00:00:00" ';
                // console.log(rfiltro);
            // }
            return rfiltro;
        },
        mtdresultadoprod(){
            var vself           = this;
            
            vself.$emit('handlerLoader', true);
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            let filtro          = vself.mtdmaisfiltro();
        
    
            let parametros      = [
                {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor : 'produtosparados'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'limit',        valor : vself.pqtdregistros},
                {parametro: 'filtrodias',   valor : filtro},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                
                vself.lstprodutosparados    = response.data.produtosparados;
            
                vself.$emit('handlerLoader', false);										
            }).catch(function (response) {
                vself.lstprodutosparados      = [];
                vself.$emit('handlerLoader', false);	
            });                
        },
    },
  mounted(){
    setTimeout(() => {
         this.mtdresultadoprod();
    }, 3000);
  },
  computed:{
    estiloScrollLista() {
        if (this.pqtdregistros >= 20) {
            return 'max-height: 150px; overflow-y: auto;';
        }
        return '';
    }
  },
}
</script>
